
export const LOGISTICS_OPC_TRANSFER: string = 'transfer-consult';
